// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const hangingLantern = defineModel({
  id: "hanging-lantern",
  batchId: "future",
  name: "Hanging lantern",
  tags: ["scenery","hanging","lantern","low-poly","age-of-mcp","future"],
  summary: "A hanging lantern — lights a doorway or yard.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.18,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.05, 0.16, 0.12), color: "#454b51", position: [-0.16, 0.5, 0] },
      { geometry: new THREE.TorusGeometry(0.12, 0.015, 4, 8, 1.963495), color: "#2f343a", position: [-0.06, 0.56, 0], rotation: [1.570796, 0.6, 0] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.08, 4), color: "#2f343a", position: [0.06, 0.62, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.07, 0.16, 6), color: "#ffe2a4", position: [0.06, 0.5, 0] },
      { geometry: new THREE.SphereGeometry(0.04, 7, 6), color: "#fff1c4", position: [0.06, 0.5, 0] },
      { geometry: new THREE.ConeGeometry(0.075, 0.07, 6), color: "#23272b", position: [0.06, 0.6, 0] },
      { geometry: new THREE.CylinderGeometry(0.075, 0.075, 0.02, 6), color: "#2f343a", position: [0.06, 0.42, 0] },
    ],
  animations: [],
});
